<div class="flex map-container h-full">
	<div class="bg-surface-container-high p-2 m-2 rounded overflow-x-scroll">
		<h3 class="text-center text-xl">PIT</h3>
		<div class="text-center text-xs pit-container">
			@for (car of carsInPit(); track car) {
				<span
					class="rounded px-2"
					[style.color]="car.foreground"
					[style.background-color]="car.background"
					>{{ car.number }}</span
				>
			}
		</div>
	</div>
	<div class="relative grow-1" #mapContainer>
		<canvas
			#trackCanvas
			class="absolute top-0 left-0"
			[width]="width()"
			[height]="height()"
		></canvas>
		<canvas class="absolute top-0 left-0" #carCanvas [width]="width()" [height]="height()"></canvas>
	</div>
</div>
